var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildDefaultProps } from '../../helpers/builders';
import { useTheme } from '../../themes';
export var BuilderInputProps = function (props) {
    var theme = useTheme();
    var wrapper = {
        width: props.isFullWidth ? '100%' : 218,
        bWidth: 'hairline',
        height: theme.fixedHeight.lg,
        bRadius: 'xs',
        bColor: props.hasError
            ? theme.brand.color.negative.pure
            : theme.neutrals.gray4,
        bStyle: 'solid',
    };
    var text = {
        labelTypographyProps: __assign({ type: 'l3', color: props.disabled ? theme.neutrals.gray4 : theme.neutrals.gray8 }, props.labelTypographyProps),
        helperTypographyProps: {
            type: 'l6',
            color: props.hasError
                ? theme.brand.color.negative.pure
                : theme.neutrals.gray5,
        },
    };
    return {
        text: buildDefaultProps(props, text),
        wrapper: buildDefaultProps(props, wrapper),
    };
};
